import React from 'react'
import { useI18n } from '../../i18n'
import type { WorkflowProgressStep } from '../../services/complianceWorkflowApi'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

interface Props {
  steps: WorkflowProgressStep[]
  onStepClick?: (key: string) => void
}

function dotClass(status: string) {
  if (status === 'complete') return wfStyles.progressDotComplete
  if (status === 'current') return wfStyles.progressDotCurrent
  return wfStyles.progressDotPending
}

function stepClass(status: string) {
  const base = wfStyles.progressStep
  if (status === 'current') return `${base} ${wfStyles.progressStepCurrent}`
  if (status === 'complete') return `${base} ${wfStyles.progressStepComplete}`
  return base
}

export default function WorkflowProgressRail({ steps, onStepClick }: Props) {
  const { t } = useI18n()
  if (!steps.length) return null

  return (
    <div className={wfStyles.progressPanel}>
      <nav aria-label={t('complianceWorkflow.workflowProgress', 'Workflow Progress')}>
        <ol className={wfStyles.progressRail}>
          {steps.map((step, i) => (
            <li key={step.key} className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => onStepClick?.(step.key)}
                className={stepClass(step.status)}
                title={step.blockerCount ? `${step.blockerCount} blockers` : undefined}
              >
                <span className={`${wfStyles.progressDot} ${dotClass(step.status)}`} aria-hidden />
                <span>{t(step.labelKey, step.key)}</span>
                {(step.blockerCount || 0) > 0 ? (
                  <span className={wfStyles.progressBlocker}>{step.blockerCount}</span>
                ) : null}
              </button>
              {i < steps.length - 1 ? (
                <span className={wfStyles.progressSeparator} aria-hidden>
                  →
                </span>
              ) : null}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}
